import store from "../../store/index"
let run = false
/* Copyright(c) 2018, iovation, inc. All rights reserved. */
window.io_global_object_name = "IGLOO"
window.IGLOO = window.IGLOO || {
    "enable_flash": false,
    "bb_callback": function (bb, complete) {
        // complete
        if (complete && !store.state.user.box) {
            store.dispatch("user/setBoxDetails", bb)
        }
    },
    "loader": {
        "subkey": "",
        "version": "5.1.0"
    }
};